<template>
  <div class="collapse-knowledge">
    <van-collapse v-model="activeNames" :border="false">
      <van-collapse-item
        v-for="(item, index) in list"
        :key="index"
        :name="item.id"
        :is-link="false"
      >
        <template slot="title">
          <CollapseKnowledgeItem :level="1" :infor="item" :isOpen="isActiveNames(item.id)" />
        </template>
        <template slot="default">
          <van-collapse v-model="activeNames" :border="false">
            <van-collapse-item
              v-for="(aitem, aindex) in item.list"
              :key="aindex"
              :name="aitem.id"
              :is-link="false"
            >
              <template slot="title">
                <CollapseKnowledgeItem
                  :infor="aitem"
                  :level="2"
                  :isOpen="isActiveNames(aitem.id)"
                />
              </template>
              <template slot="default">
                <van-collapse v-model="activeNames" :border="false">
                  <van-collapse-item
                    v-for="(bitem, bindex) in aitem.list"
                    :key="bindex"
                    :name="bitem.id"
                    :is-link="false"
                  >
                    <template slot="title">
                      <CollapseKnowledgeItem
                        :infor="bitem"
                        :level="2"
                        :isOpen="isActiveNames(bitem.id)"
                      />
                    </template>
                  </van-collapse-item>
                </van-collapse>
              </template>
            </van-collapse-item>
          </van-collapse>
        </template>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import CollapseKnowledgeItem from './CollapseKnowledgeItem.vue'
export default {
  components: { CollapseKnowledgeItem },
  props: {
    list: Array,
  },
  data() {
    return {
      activeNames: [],
    }
  },
  computed: {
    isActiveNames() {
      return function (id) {
        return this.activeNames.indexOf(id) >= 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.collapse-knowledge {
  ::v-deep {
    .van-cell,
    .van-collapse-item__content {
      padding: 0;
    }
  }
}
</style>
